var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExportDispatch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16651 17.5031H4.37285C3.33689 17.5031 2.49707 16.6633 2.49707 15.6273V6.78194C2.49707 6.52863 2.54853 6.27795 2.64797 6.04497L3.67756 3.63563C3.97302 2.94522 4.65147 2.49729 5.40245 2.49683H14.5971C15.3482 2.49707 16.0267 2.94507 16.322 3.63563L17.3516 6.04497C17.4516 6.2778 17.5033 6.52854 17.5033 6.78194V9.99995",
    stroke: "#736EEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3369 15.0021V15.0021C18.3369 16.8438 16.8439 18.3368 15.0022 18.3368V18.3368C13.1605 18.3368 11.6675 16.8438 11.6675 15.0021V15.0021C11.6675 13.1604 13.1605 11.6674 15.0022 11.6674V11.6674C16.8439 11.6674 18.3369 13.1604 18.3369 15.0021Z",
    stroke: "#736EEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0023 13.8907V16.1133",
    stroke: "#736EEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1685 14.7244L15.0021 13.8907L15.8358 14.7244",
    stroke: "#736EEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 2.49683V6.66523",
    stroke: "#736EEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83154 14.1683H7.4989",
    stroke: "#736EEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5033 8.33264C17.5033 7.41179 16.7568 6.66528 15.836 6.66528H4.16443C3.24357 6.66528 2.49707 7.41179 2.49707 8.33264",
    stroke: "#736EEF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExportDispatch);
export default ForwardRef;